module.exports = __webpack_public_path__ + "static/media/team-5@2x.32c0fb4e.jpg";